const e = () => ({
  feedbackHeight: "unset",
  feedbackPadding: "4px 0 0 0",
  feedbackTextColor: "var(--gray-600)",
  feedbackTextColorError: "var(--error-500)",
  feedbackTextColorWarning: "var(--gray-600)",
  labelFontWeight: "500",
  labelPadding: "0 0 4px 0"
}), r = {
  lg: "xl",
  md: "lg",
  sm: "md",
  xs: "sm",
  "2xs": "xs",
  "3xs": "2xs"
};
export {
  r as feedbackTextAndFontSize,
  e as getFormItemCommonStyles
};
//# sourceMappingURL=highrise.es350.js.map
